<template>
  <div class="seomain">
    <st-header
      :title="formData.id ? '编辑收款单' : '添加收款单'"
      :back-able="true"
    >
    </st-header>
    <div class="st-form-content">
      <st-form ref="form">
        <!-- <div class="st-form-title">基本信息</div> -->
        <div class="st-form-group">

          <van-cell-group inset>
            <st-form-item key="corporation_out_id" label="美金账户（支出账户）" prop="corporation_out_id" :required="true">
              <st-select
                v-model="formData.corporation_out_id"
								:defText="formData.corporation_out_name"
                name="美金账户（支出账户）"
                placeholder="请选择美金账户（支出账户）"
                :options="$option['getCorporation']"
								:custom-params="{'currency': 'USD'}"
								:clearable="true"
              >
              </st-select>
            </st-form-item>
						
						<st-form-item key="corporation_in_id" label="人民币账户（收入账户）" prop="corporation_in_id" :required="true">
						  <st-select
						    v-model="formData.corporation_in_id"
								:defText="formData.corporation_in_name"
						    name="人民币账户（收入账户）"
						    placeholder="请选择人民币账户（收入账户）"
						    :options="$option['getCorporation']"
								:custom-params="{'currency': 'RMB'}"
								:clearable="true"
						  >
						  </st-select>
						</st-form-item>

						<st-form-item key="paymenttime" label="兑换日期" prop="paymenttime" :required="true">
							<st-date
								v-model="formData.paymenttime"
								date-type="date"
								name="兑换日期"
								placeholder="请选择兑换日期"
							></st-date>
						</st-form-item>
						
						
						<st-form-item key="out_amount" label="兑换金额（美金）" prop="out_amount" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.out_amount"
						    name="兑换金额（美金）"
						    label=""
						    placeholder="请填写兑换金额（美金）"
						  />
						</st-form-item>
						
						<st-form-item key="exchange_rate" label="汇率（美金兑人民币）" prop="exchange_rate" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.exchange_rate"
						    name="汇率（美金兑人民币）"
						    label=""
						    placeholder="请填写汇率（美金兑人民币）"
						  />
						</st-form-item>
						
						<st-form-item key="in_amount" label=" 折算人民币金额" prop="in_amount" :required="true">
						  <van-field
						    class="st-form-item-input"
								:value="inAmount"
						    name=" 折算人民币金额"
						    label=""
						    placeholder="请填写 折算人民币金额"
								:disabled="true"
						  />
						</st-form-item>

            <st-form-item key="remark" label="备注" prop="remark"  :required="true">
							<van-field
								class="st-form-item-input"
								v-model="formData.remark"
								name="备注"
								label=""
								placeholder="请填写备注"
							/>
            </st-form-item>
						
						
						<st-form-item key="receipt_images" label="水单" prop="receipt_images">
						  <st-file-upload
						    v-model="formData['receipt_images']"
						  >
						  </st-file-upload>
						</st-form-item>
          </van-cell-group>
        </div>
        
        <div style="margin: 16px;" class="form-submit-button">
          <van-button round block type="primary"  @click="onSubmit">
            提交
          </van-button>
        </div>
      </st-form>
    </div>
    
  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StSelect from "@/components/Select.vue";
import StDate from "@/components/Date.vue";
import StHeader from "@/components/layout/Header.vue";
import StForm from "@/components/form.vue";
import StFormItem from "@/components/formItem.vue";

export default {
  components: {
    'st-file-upload': StFileUpload,
    'st-select': StSelect,
    "st-header": StHeader,
    "st-form-item": StFormItem,
		StForm,
		StDate
  },
  props: {},
  data() {
    return {
      formRule: {},
      formData: {
				currency: 'CNY',
				out_amount: '',
				exchange_rate: '',
				in_amount: '',
				receipt_images: [],
      }, 
      loading: false,
      actField: '',
      actOptions: [],
    };
  },
  watch: {},
	computed: {},
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "添加采购订单" });
    });
  },
	computed: {
		 inAmount: function() {
			 return this.formData.in_amount = this.formData.exchange_rate * this.formData.out_amount;
			}
	},
  mounted() {},

  methods: {
    init() {
			let id = parseInt(this.$route.query.id);
			this.formData.id = isNaN(id) ? 0 : id;
			this.getUpdateData();
		},
		// 获取编辑需要显示的数据
		getUpdateData() {
			if (this.formData.id) {
				this.$post(`${this.$api.exchangeUsdToRmbEditInfo}`, {id: this.formData.id}).then((res) => {
					let data = res.data;
					this.formData = data;
				}).catch((err) => {
					window.history.go(-1);
					console.log('exchange/edit', err);
				});
			} else {
				this.$post(this.$api.stGetRates + "USD", {}).then((res) => {
					this.formData.exchange_rate = res.data;
				});
				
				this.$post(`${this.$api.stIncomeOrderGeneCode}`, {}).then((res) => {
					this.$set(this.formData, ['code'], res.data)
				});
			}
		},

    // 提交表单
    onSubmit() {
     this.$refs.form.validater.valid((isValid, lastError) => {
        if (!isValid) {
          this.$toast.fail('表单异常：' + lastError);
        }
      });
			
      let formData = JSON.parse(JSON.stringify(this.formData));
			formData['receipt_images'] = formData['receipt_images'].map((item) => { return item.url; }).join(',');
			if (this.formData.id) {
				this.updateData(formData);
			} else {
				this.addData(formData);
			}
      
    },
		
		addData(formData) {
			this.$post(this.$api.exchangeUsdToRmbAdd, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '创建异常');
			  } else {
			    this.$toast.success("创建成功");
			    this.$router.replace(`/exchange/list`);
			  }
			});
		},
		updateData(formData) {
			this.$post(this.$api.exchangeUsdToRmbEdit, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '编辑异常');
			  } else {
			    this.$toast.success("编辑成功");
			    this.$router.replace(`/exchange/list`);
			  }
			});
		},
  },
};
</script>

<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;
	form {
		overflow: hidden;
	}
	
  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
		padding-bottom: 16px;
		border-radius: 5px;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .form-submit-button {
      margin-top: 12px;
    }

  }

}

</style>
